import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BzgToastService, BzgToastType } from 'bz-genome-angular';
import { IConetionConfiguration } from '../core/interfaces/IConetionConfiguration';
import { IReportConfiguration } from '../core/interfaces/IReportConfiguration';
import { PowerBIService } from '../core/services/powerbi.service';
  
@Component({
  selector: 'dv-powerbi',
  templateUrl: './dv-power-bi.component.html',
  styleUrls: ['./dv-power-bi.component.scss']
})
export class PowerBIComponent implements OnInit {
  powerBIConfigurations: IConetionConfiguration[] = [];
  powerBIConfiguration: IConetionConfiguration = null;
  reportConfiguration: IReportConfiguration = null;
  currentItemSelected: string = '';
  currentItemReportSelected: string = '';
  isLoading: boolean = false;
  isConexion: boolean = true;
  anyItemSelected: boolean = false;
  constructor(private powerBIServices: PowerBIService,
              private _toastService: BzgToastService,
              private _translateService: TranslateService) { }

  ngOnInit() {
    this.loadTable();
  }

  loadTable() {
    this.isLoading = true;
    this.powerBIServices.getPowerBIConfigurations().subscribe((result: any) => {
      this.powerBIConfigurations = [];
      if (result.Successful) this.powerBIConfigurations = result.Data;
      else this.showToast(result.ExceptionMessage, 'error', 0);
      this.isLoading = false;
    });
  }

  showToast(messageInput: string, type: BzgToastType, duration: number) {
    this._translateService.get(messageInput).subscribe((message: string) => {
      this._toastService.open(
        message,
        {
          type,
          duration: duration,
          verticalPosition: 'top',
          horizontalPosition: 'right'
        });
      }
    );
  }

  clickItem(configurationConexion: IConetionConfiguration) {
    this.isConexion = true;
    if (this.currentItemSelected !== configurationConexion.Id)
    {
      this.currentItemSelected = configurationConexion.Id;
      this.powerBIConfiguration = configurationConexion;
      this.anyItemSelected = true;
      return;
    }
    if (this.currentItemSelected === configurationConexion.Id)
    {
      this.resetValues();
      this.anyItemSelected = true;
    }
  }

  clickItemReport(configurationReport: IReportConfiguration) {
    this.isConexion = false;
    if (this.currentItemReportSelected !== configurationReport.Id)
    {
      this.currentItemReportSelected = configurationReport.Id;
      this.reportConfiguration = configurationReport;
      this.anyItemSelected = true;
      return;
    }
    if (this.currentItemReportSelected === configurationReport.Id)
      this.resetValues();
  }

  resetValues () {
    this.currentItemReportSelected = '';
    this.reportConfiguration = null;
    this.anyItemSelected = false;
  }

  collapseItems(collapse: boolean, configurationConexion: string) {
    if (collapse) {
      this.resetValues();
      this.currentItemSelected = '';
    } else
    {
      this.currentItemSelected = configurationConexion;
      this.powerBIConfiguration = this.powerBIConfigurations.find(power => power.Id === this.currentItemSelected);
    }
  }

  updateTable() {
    this.loadTable();
  }

  isSelected(id: string): boolean {
    if (this.isConexion)
      return this.currentItemSelected === id ? true : false;
    else
      return this.currentItemReportSelected === id ? true : false;
  }

  isOpen(id: string): boolean {
    return this.currentItemSelected === id ? true : false;
  }
}
